import React, { useState } from 'react'
import Parametros from './Parametros'
import ParametrosHorasExtrasContextProvider from 'Context/ParametrosHorasExtrasContext'
import { Tab, Tabs } from 'react-bootstrap';
import { Row, Col } from "reactstrap"
import ParametrosPlanificacion from './Parametros Planificacion/ParametrosPlanificacion';
import ParametrosMensualesHorasExtrasContextProvider from 'Context/ParametrosMensualesHorasExtrasContext';
import ActividadesHorasExtras from './Actividades/ActividadesHorasExtras';
import GruposActividadesHorasExtras from './Grupos Actividades/GruposActividadesHorasExtras';
import NewParametrosPlanificacion from './NewParametrosPlanificacion';
import NewParametrosProyeccion from './NewParametrosProyeccion';

export default function ContainerParametros() {
    const TITULO_PANTALLA = "PARÁMETROS DEL SISTEMA";

    //const [activeTab, setActiveTab] = useState<string | null>('Parametros');

    const [activeTab, setActiveTab] = useState<string | null>('Proyeccion');
    const handleTabChange = (tab: string | null) => {

        setActiveTab(tab); // Actualiza la pestaña seleccionada
    };




    return (
        <ParametrosHorasExtrasContextProvider>
            <ParametrosMensualesHorasExtrasContextProvider>

                <div className='content'>

                    <h4>{TITULO_PANTALLA}</h4>


                    <Tabs
                        id="tabParametrosHorasExtras"

                        activeKey={activeTab}
                        className='tab_Planificacion_HE'
                        onSelect={handleTabChange}
                    >
                        {/* <Tab
                            eventKey='Parametros'
                            title="PROYECCIÓN Y PLANIFICACIÓN MENSUAL"
                            className='tab_Planificacion_HE'
                        >
                            <Parametros />
                        </Tab> */}

                        <Tab
                            eventKey='Proyeccion'
                            title="PROYECCIÓN Y PRESUPUESTO"
                            className='tab_Planificacion_HE'
                        >
                            {activeTab === "Proyeccion" && <NewParametrosProyeccion />}
                        </Tab>

                        <Tab
                            eventKey='Planificacion'
                            title="PLANIFICACIÓN Y PAGO"
                            className='tab_Planificacion_HE'
                        >
                            {
                                activeTab === "Planificacion" && <NewParametrosPlanificacion />
                            }

                        </Tab>





                        <Tab
                            eventKey='Grupo'
                            title="GRUPO"
                            className='tab_Planificacion_HE'
                        >
                            {activeTab === "Grupo" && <GruposActividadesHorasExtras />}
                        </Tab>




                        <Tab
                            eventKey='Actividades'
                            title="ACTIVIDADES"
                            className='tab_Planificacion_HE'
                        >
                            {activeTab === "Actividades" && <ActividadesHorasExtras />}

                        </Tab>
                    </Tabs>
                </div>
            </ParametrosMensualesHorasExtrasContextProvider>

        </ParametrosHorasExtrasContextProvider>


    )
}
